import styles from './Screener.module.scss'
import Button from '@mui/material/Button';
import { useGeneral } from '../../../context/general'
import Spinner from "../../Spinner"
import Modal from '../../Modal'
import { useState } from 'react';
import { Typography } from '@mui/material'

const TickerDataCell = ({ticker, companyName, project}) => {
    // const { url } = useCompanyLogo(ticker)
    const { handleCreateProjectAndOpen } = useGeneral()
    const [ modal, setModal ] = useState('')
    const handleCloseModal = () => setModal(false)
    const OpenModal = () => {
        setModal('Setting up project')
    }

    
    const CreateNewProject = () =>{
        handleCreateProjectAndOpen(ticker)
    }
    return (
        <>
        {/* <div className={styles['company-data-cell']}>
            <CompanyLogo image={url && (url.image ?? '')} ticker={ticker} size={32} />
        </div> */}
        <Button variant="text" style={{color:'#dccb03'}} onClick={CreateNewProject}>{ticker}</Button>
        <Modal open={!!modal} handleClose={handleCloseModal}>
            <div className="newsGraphModalContent">
                <Spinner hasText={false} />
                <Typography variant="h3">
                    {modal}
                </Typography>
            </div>
        </Modal> 
        </>
    )
}

export default TickerDataCell